module.exports = __webpack_public_path__ + "static/media/teygja_abs.62ed04ac.png";